export type ClientIdentifier = {
  client: string,
  version: string,
}

/**
 * Searches the provided user-agent string for the known clients and their versions.
 *
 * @param userAgent The user agent string
 * @param knownClients A list of known clients to look for in the user agent string
 * @returns a list of known clients and their specified versions
 */
export const parseKnownClientsFromUserAgent = (
  userAgent: string,
  knownClients: string[],
): ClientIdentifier[] => {
  return userAgent.match(/\b([\w.-]+)\/([\d.]+)\b/g).reduce((acc, match) => {
    const [client, version] = match.split('/')
    if (knownClients.includes(client)) {
      return [...acc, { client, version }]
    }

    return acc
  }, [])
}
